var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChessBoardLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    rx: 150,
    fill: "#AAAAAA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.4286 0C32.0312 0 0 32.0312 0 71.4286V428.571C0 467.969 32.0312 500 71.4286 500H428.571C467.969 500 500 467.969 500 428.571V71.4286C500 32.0312 467.969 0 428.571 0H71.4286ZM142.857 71.4286V142.857H214.286V71.4286H285.714V142.857H357.143V71.4286H428.571V142.857H357.143V214.286H428.571V285.714H357.143V357.143H428.571V428.571H357.143V357.143H285.714V428.571H214.286V357.143H142.857V428.571H71.4286V357.143H142.857V285.714H71.4286V214.286H142.857V142.857H71.4286V71.4286H142.857ZM214.286 214.286H285.714V142.857H214.286V214.286ZM214.286 285.714V214.286H142.857V285.714H214.286ZM285.714 285.714H214.286V357.143H285.714V285.714ZM285.714 285.714H357.143V214.286H285.714V285.714Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChessBoardLogo);
export default __webpack_public_path__ + "static/media/Chess Board Logo.f84db6816674dd9a69d537505e9dfb16.svg";
export { ForwardRef as ReactComponent };